export default {
  SEARCH_CATALOG_ALLIANZ_QUESTIONNAIRE_TEMPLATE_QUERY: Symbol.for('SEARCH_CATALOG_ALLIANZ_QUESTIONNAIRE_TEMPLATE_QUERY'),
  CATALOG_ALLIANZ_QUESTIONNAIRE_TEMPLATE_REPOSITORY: Symbol.for('CATALOG_ALLIANZ_QUESTIONNAIRE_TEMPLATE_REPOSITORY'),
  CATALOG_ALLIANZ_QUESTIONNAIRE_TEMPLATE_STATE_MANAGER: Symbol.for('CATALOG_ALLIANZ_QUESTIONNAIRE_TEMPLATE_STATE_MANAGER'),
};
